module.exports = __webpack_public_path__ + "static/media/unsupport-img.a4e1f138.png";